import { toast } from 'react-toastify';
import { postAsync, SHJC_URL } from "../components/helper/axiosHelper";

export const PageHitCountApi = async (pageLink, userID ) => {
  // const { t } = useTranslation();
  const role = localStorage.getItem('role');

  const payload = {
    pageLogID: 0,
    pageName: SHJC_URL+pageLink,
    userTypeID: role ? (role === 'Admin' ? 2 :  1) : 3 ,
    userID: userID
  }
  try {
    const result = await postAsync(`Utilities/CreatePageLog`, payload)
    if (result.statusCode === 400) {
      toast.error(result?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}